<ng-container *ngIf="form">
  <form [formGroup]="form">
    <h3 class="flex">
      <span>Save view</span>
    </h3>

    <div class="flex flex-start flex-row mt-4">
      <mat-form-field class="fw" (click)="$event.stopPropagation()">
        <input matInput formControlName="name" type="name" placeholder="View name" />
        <mat-error *ngIf="form.get('name')?.hasError('name') && !form.get('name')?.hasError('required')">
          View name is required
        </mat-error>
      </mat-form-field>
    </div>

    <div class="flex flex-start flex-row -mt-4 -ml-4">
      <hospitable-checkbox
        [checked]="publiclyAvailable"
        (change)="publiclyAvailable = $event"
        [label]="'Make this view public'"></hospitable-checkbox>
    </div>

    <div class="flex mt-4 flex-row-reverse">
      <sbnb-button
        label="Save"
        [loading]="(loadingState$ | async) === LoadingState.Pending"
        (clicked)="onSaveView()"
        [disabled]="!form.valid"></sbnb-button>
    </div>
  </form>
</ng-container>
